import { Page, ViewController } from 'ionic-angular';
import { Component } from '@angular/core'
import { Http } from '@angular/http';

import { DOMAIN } from '../../config';

@Component({
  templateUrl: 'build/pages/more/more.html'
})

export class MoreModal {
  private categories: any = Array;

  constructor(private http: Http, private controller: ViewController) {
    this.categories = [];
    this.http
      .get(`//${DOMAIN}/api/categories`)
      .map(res => res.json())
      .subscribe(data => {
        this.categories = data.sort((a, b) => {
          return +(a.nom > b.nom) || +(a.nom === b.nom) -1;
        });
      });
  }

  dismiss() {
    this.controller.dismiss()
  }
}
